import { useQuery } from "@tanstack/react-query";
import AppContext from "PFApp/app_context";
import { useSession } from "PFApp/use_session";
import { QueryOptions } from "PFTypes/request_options";
import { useContext } from "react";

import { fetchSkillsProfileData, ProfilePath } from "../../../services/insights/skills_profile_api";
import { queryKeys } from "./query_keys";

type ChildNode = {
  cnt: number;
  count_total: number;
  id: string;
  name: string;
  skill_level: number;
  uniq: number;
  value: number;
};

type ParentNode = {
  children: ChildNode[] | ParentNode[];
  id: string;
  name: string;
  values: number;
};

export type SkillsProfileData = {
  sunburst: {
    id: string;
    name: string;
    children: ParentNode[];
  };
};

type UseSkillsProfileQuery = {
  params: Record<string, any>;
  path: ProfilePath;
};

export const useSkillsProfileQuery = (
  { params, path }: UseSkillsProfileQuery,
  options?: QueryOptions<SkillsProfileData>
) => {
  const session = useSession();
  const {
    store: { currentAccount }
  } = useContext(AppContext);
  return useQuery<SkillsProfileData>(
    queryKeys.skillsProfile(path, params),
    async () =>
      await fetchSkillsProfileData(path, session.getAccessToken(), currentAccount.full_domain, params),
    options
  );
};
